import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useSupportPlanEventStore = defineStore('supportPlanEvent', () => {
    const all = ref({ data: [] });
    const supportPlanEvents = ref({});
    const active = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const searchSupportPlanEvents = async (params) => {
        return axios.post(`/api/v1/support-plan/${params.hash}/events`, params);
    };

    const createBlankEvent = (payload) => {
        return axios.post('/api/v1/support-plan/event', payload);
    };

    const updateSupportPlanEvent = (payload) => {
        return axios.patch(`/api/v1/support-plan/event/${payload.hash}`, payload);
    };

    const deleteSupportPlanEvent = (eventHash) => {
        return axios.delete(`/api/v1/support-plan/event/${eventHash}`);
    };

    return {
        all,
        reset,
        searchSupportPlanEvents,
        createBlankEvent,
        updateSupportPlanEvent,
        deleteSupportPlanEvent,
        supportPlanEvents,
        active,
    };
});
